module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "f5 db mb3"
  }, [_vm._v("Student Verification")]), _vm._v(" "), _c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "school"
    }
  }, [_vm._v("School Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentData.school),
      expression: "studentData.school"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "school",
      "type": "text"
    },
    domProps: {
      "value": (_vm.studentData.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.studentData, "school", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Please upload proof of your student status (school ID, unofficial transcript, receipt of tuition paid, or class schedule)")]), _vm._v(" "), _c('div', {
    staticClass: "pv5 w-100 tc mb5",
    class: _vm.filePickerClass
  }, [_c('input', {
    staticClass: "input-reset dn",
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "image/*, .pdf,.heic,.heif,.HEIC,.HEIF"
    },
    on: {
      "change": function($event) {
        return _vm.processImage($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "dib fw5 pv2 ph5 br-pill pointer ba bw1 white",
    class: _vm.studentData.studentValidation.name ? 'bg-green b-green' : 'bg-theme b-theme',
    attrs: {
      "for": "file"
    }
  }, [_c('svg', {
    staticClass: "v-sub mr1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18",
      "viewBox": "0 0 20 18",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.studentData.studentValidation.name ? 'File Selected' : 'Upload Transcript/ID'))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529f83bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment-methods/shared/components/StudentForm.vue
// module id = 1222
// module chunks = 0